import { useCostosModel } from '../../../modelos/Costos/modeloCostos';
import FileUploader from '../../../components/FileUploader';
import { formatearFechaCompleta, formatearFechaCorta, formatearPrecio, toYYYYMMDD } from '../../../utils/utils';
import React, { useEffect, useState, useCallback } from 'react';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { useCuentaCobroModel } from '../../../modelos/CuentasCobro/modeloCuentasCobro';
import {
  UploadCloud, FileText, Trash2, CheckCircle, Paperclip, RefreshCw, DollarSign, Hash
} from 'lucide-react'; 
import EditableField from '../../../components/EditableFields';

const CuentaDeCobroCard = ({ cuenta }) => {
  const esPagado = cuenta.estado;

  const{
    updateCuentaCobro,
    getPagosReferenciasCuentaCobro,
  } = useCuentaCobroModel();

  const {
      configuracion
    } = useConfiguracion();

  const [pagosRelacionados, setPagosRelacionados] = useState({
      cargando: true,
      error: null,
      datos: [],
  });

  // fetch pagos relacionados
  const fetchPagosRelacionados = useCallback(async () => {
    if (!cuenta.referenciaPago || !configuracion.nombreEmpresa) {
      setPagosRelacionados({ cargando: false, error: null, datos: null });
      return;
    }
    try {
      setPagosRelacionados({ cargando: true, error: null, datos: null });
      const resultado = await getPagosReferenciasCuentaCobro(cuenta.fechaPagadoPorNosotros, configuracion.nombreEmpresa, cuenta.referenciaPago, cuenta.nameTutor);
      
      console.log("resultado", resultado, cuenta.nameTutor);

      setPagosRelacionados({ cargando: false, error: null, datos: resultado });
    } catch (err) {
      console.error("Error al obtener pagos relacionados:", err);
      setPagosRelacionados({ cargando: false, error: 'No se pudieron cargar los pagos.', datos: null });
    }
  }, [cuenta.referenciaPago, cuenta.fechaPagadoPorNosotros, cuenta.nameTutor, configuracion.nombreEmpresa, getPagosReferenciasCuentaCobro]);

  //cargar referencias pagadas
  useEffect(() => {
    console.log("cuenta de cobro", cuenta.nameTutor);
    fetchPagosRelacionados();
  }, [fetchPagosRelacionados]);


  const pagoEsperado = cuenta.precioPagado;
  const pagoRealVerificado = pagosRelacionados.datos?.totalPagadoTutorConAutopagos ?? null;
  const montosCoinciden = pagoEsperado === pagoRealVerificado;

  //archivo
  const [archivoCuentaCobro, setarchivoCuentaCobro] = useState({
    archivoCuentaCobro: null,
  });

  //datosCuentaCobro
  const [nuevaCuentaCobro, setnuevaCuentaCobro] = useState({
      precioPagado: 0,
      fechaPagadoPorNosotros: new Date(),
      referenciaPago: '',
    });


  const handleSave = async(documentID,field,value) =>{
   await updateCuentaCobro(documentID,configuracion.nombreEmpresa,field,value,'field',archivoCuentaCobro);

    setarchivoCuentaCobro({
      archivoCuentaCobro: null,
    })

  }
  
  const ProcesoPago = () => {

    if (!cuenta.urlArchivo) {
      return (
        <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-dashed border-gray-300">
          <label htmlFor="cuentaCobro" className="block text-sm font-medium text-gray-700 mb-2">Sube la cuenta de cobro (PDF):</label>
          <FileUploader
            formData={archivoCuentaCobro}
            setFormData={setarchivoCuentaCobro}
            fieldName="archivoCuentaCobro"
            allowedTypes={['application/pdf']}
            maxSize={10 * 1024 * 1024}
            label="Seleccionar archivo PDF"
            multiple={false}
          />
          {archivoCuentaCobro.archivoCuentaCobro && (
            <button
              onClick={() => {
                handleSave(cuenta.idDocumento, 'urlArchivo', '');
              }}
              className="w-full mt-3 flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
            >
              <UploadCloud size={16} />
              Confirmar Subida
            </button>
          )}
        </div>
      );
    }

    if (cuenta.urlArchivo) {
      return (
        <div className="mt-4 space-y-4">

          <div>
              {montosCoinciden
                  ? <div className="text-green-600">✅ El pago está conciliado.</div>
                  : <div className="text-yellow-600">⚠️ Hay una diferencia por revisar.</div>
              }
          </div>

          <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg border border-green-200">
            <div className="flex items-center gap-2">
              <FileText size={18} className="text-green-600" />
              <span className="text-sm font-medium text-green-800">Cuenta de cobro recibida</span>
            </div>
            <div className="flex items-center gap-2">
              <a href={cuenta.urlArchivo} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-blue-600 hover:underline">Ver</a>
              <button onClick={() => { handleSave(cuenta.idDocumento, 'urlArchivo', ''); }} className="text-red-500 hover:text-red-700"><Trash2 size={16} /></button>
            </div>
          </div>

          
        
          {
          (cuenta.referenciaPago === "" && cuenta.precioPagado === 0) ? (
            <div className="p-4 bg-gray-50 rounded-lg space-y-3">
              <h4 className="text-sm font-semibold text-gray-800">Registrar Pago</h4>
              <div>
                <label className="text-xs font-medium text-gray-500">Valor Pagado</label>
                <input
                  type="number"
                  value={nuevaCuentaCobro.precioPagado}
                  onChange={(e) => setnuevaCuentaCobro({ ...nuevaCuentaCobro, precioPagado: e.target.value })}
                  placeholder={formatearPrecio(cuenta.precioCobro)}
                  className="w-full mt-1 p-2 text-sm border border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="text-xs font-medium text-gray-500">Referencia de Pago</label>
                <input
                  type="text"
                  value={nuevaCuentaCobro.referenciaPago}
                  onChange={(e) => setnuevaCuentaCobro({ ...nuevaCuentaCobro, referenciaPago: e.target.value })}
                  placeholder="Ej: Nequi-12345"
                  className="w-full mt-1 p-2 text-sm border border-gray-300 rounded-md"
                />
              </div>
              <button
                onClick={async () => {
                  await handleSave(cuenta.idDocumento, 'precioPagado', nuevaCuentaCobro.precioPagado);
                  await handleSave(cuenta.idDocumento, 'referenciaPago', nuevaCuentaCobro.referenciaPago);
                  await handleSave(cuenta.idDocumento, 'fechaPagadoPorNosotros', nuevaCuentaCobro.fechaPagadoPorNosotros);
                }}
                className="w-full flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors"
              >
                <CheckCircle size={16} />
                Registrar informacion
              </button>
            </div>
          ) : (
            // ESTE ES EL 'ELSE' (SI ES FALSO)
            <div className="text-center p-2 bg-gray-100 rounded-md">
              
              <EditableField
                field="precioPagado"
                label="Valor pagado por nosotros"
                value={cuenta.precioPagado}
                type="number"
                isAdmin={true}
                onSave={(field,value) =>{
                  handleSave(cuenta.idDocumento,field,value);
                }}
              />

              <EditableField
                field="referenciaPago"
                label="Referencia de pago"
                value={cuenta.referenciaPago}
                type="text"
                isAdmin={true}
                onSave={(field,value) =>{
                  handleSave(cuenta.idDocumento,field,value);
                }}
              />

              <EditableField
                field="fechaPagadoPorNosotros"
                label="Referencia de pago"
                value={cuenta.fechaPagadoPorNosotros}
                type="datetime"
                isAdmin={true}
                onSave={(field,value) =>{
                  handleSave(cuenta.idDocumento,field,value);
                }}
              />

              {/* Marcar como pagado */}
              {!cuenta.estado && (
                <button
                    onClick={async () => {
                      await handleSave(cuenta.idDocumento, 'estado', true);
                    }}
                    className="w-full flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors"
                  >
                    <CheckCircle size={16} />
                    Marcar como pagada
                  </button>
              )}

              {/* Info de pagos, recibido desde el servidor */}
              <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200 text-left">
                <div className="flex justify-between items-center mb-3 border-b pb-2">
                  <h5 className="text-sm font-semibold text-gray-800">
                      Comprobantes Asociados a la Referencia
                  </h5>
                  {/* ESTE ES EL NUEVO BOTÓN */}
                  <button
                    onClick={fetchPagosRelacionados} // Llama a la función directamente
                    className="p-1 text-blue-600 hover:bg-blue-100 rounded-full transition-colors"
                    title="Actualizar pagos"
                    disabled={pagosRelacionados.cargando} // Deshabilita mientras carga
                  >
                    <RefreshCw size={16} className={pagosRelacionados.cargando ? 'animate-spin' : ''} />
                  </button>
                </div>
                
                {pagosRelacionados.cargando ? (
                    <p className="text-sm text-gray-500">Buscando pagos...</p>
                ) : pagosRelacionados.error ? (
                    <p className="text-sm text-red-500">{pagosRelacionados.error}</p>
                ) : pagosRelacionados.datos && pagosRelacionados.datos.pagosDetallados.length > 0 ? (
                    // Usamos un Fragment (<>) para agrupar la sección de resumen y la lista
                    <>
                        {/* --- SECCIÓN DE RESUMEN DE TOTALES --- */}
                        <div className="mb-4 space-y-2 text-sm">
                            <div className="flex justify-between">
                                <span className="text-gray-600">Total Pagos Registrados:</span>
                                <span className="font-semibold text-gray-800">
                                    {pagosRelacionados.datos.totalPagos}
                                </span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-gray-600">Total Reembolsos:</span>
                                <span className="font-semibold text-gray-800">
                                    {pagosRelacionados.datos.totalReembolsoTutor}
                                </span>
                            </div>
                            <div className="flex justify-between text-base mt-2 pt-2 border-t">
                                <span className="font-bold text-blue-800">Neto Pagado al Tutor:</span>
                                <span className="font-bold text-blue-800">
                                    {pagosRelacionados.datos.totalPagadoTutorConAutopagos}
                                </span>
                            </div>
                        </div>

                        
                    </>
                ) : (
                    <p className="text-sm text-gray-500">No se encontraron otros pagos con esta referencia.</p>
                )}
            </div>

            </div>
          )
          }


        </div>
      );
    }

    return null;

  };

  return (
    <div className={`p-5 rounded-2xl shadow-lg transition-all ${esPagado ? 'bg-green-50/50 border-l-4 border-green-500' : 'bg-white border-l-4 border-blue-500'}`}>
      <div className="flex items-start justify-between pb-4 border-b border-gray-200">
        <div>
          <p className="text-xs text-gray-500 font-mono">{cuenta.idDocumento}</p>
          <h3 className="text-lg font-bold text-gray-800">Cuenta #{cuenta.idPago}</h3>
          {/* Se ajusta la lógica para mostrar el precio a cobrar si aún no se ha pagado */}
          <p className="text-2xl font-bold text-gray-900">{formatearPrecio(cuenta.precioPagado)} - {formatearPrecio(cuenta.precioCobro)}</p>
        </div>
        <div className="flex items-center gap-2">
          {esPagado ? (
            <span className="flex items-center gap-1.5 px-3 py-1 text-xs font-bold text-green-800 bg-green-200 rounded-full">
              <CheckCircle size={14} /> Pagado
            </span>
          ) : (
            <span className="flex items-center gap-1.5 px-3 py-1 text-xs font-bold text-blue-800 bg-blue-200 rounded-full">
              <Paperclip size={14} /> Por Pagar
            </span>
          )}
        </div>
      </div>

      <div className="pt-4 space-y-3">
        {/* Información del Tutor */}
        <div className="flex justify-between items-center p-2 text-sm text-gray-700 bg-gray-100 rounded-md">
          <span className="font-medium">Tutor: {cuenta.nameTutor}</span>
          {cuenta.autoPagos && <span className="text-xs font-bold text-purple-600 bg-purple-100 px-2 py-1 rounded-full">AutoPago</span>}
        </div>

        {/* Fechas y Detalles */}
        <div className="grid grid-cols-2 gap-x-4 text-sm">
          <div className="text-gray-600">Fecha de Cobro (Tutor):</div>
          <div className="font-semibold text-gray-800 text-right">{formatearFechaCompleta(cuenta.fechaPago)}</div>
          
          {esPagado && (
            <>
              <div className="mt-1 pt-1 border-t col-span-2"></div>
              <div className="text-gray-600">Fecha de Nuestro Pago:</div>
              <div className="font-semibold text-gray-800 text-right">{formatearFechaCorta(cuenta.fechaPagadoPorNosotros)}</div>
              <div className="text-gray-600">Referencia:</div>
              <div className="font-mono text-xs font-semibold text-gray-800 text-right">{cuenta.referenciaPago}</div>
            </>
          )}
        </div>
      </div>
      
      {ProcesoPago()}
    </div>
  );


};

export default CuentaDeCobroCard;